<template>
  <div class="member-filter-window d-flex flex-column align-items-center w-100 p-4 position-absolute top-0 start-0">
    <div class="d-flex justify-content-end w-100">
      <a href="#" @click="closeMemberFilterForm"><i class="el-icon-close"></i></a>
    </div>
    <div class="w-75 d-flex flex-column align-items-center">
      <h3>篩選會員</h3>
      <el-tabs v-model="activeTab" stretch class="w-100">
        <el-tab-pane v-for="tab in tabList" :key="tab.key" :label="tab.label" :name="tab.key"></el-tab-pane>
      </el-tabs>
      <el-form ref="memberFilterForm" :model="memberFilterData" class="w-100">
        <template v-if="activeTab === 'level'">
          <el-form-item label="會員性別">
            <br />
            <el-radio-group v-model="memberFilterData.gender" class="w-100 d-flex justify-content-between">
              <el-radio label="female" border class="half-item rounded">女性</el-radio>
              <el-radio label="male" border class="half-item rounded">男性</el-radio>
            </el-radio-group>
          </el-form-item>
          <div class="d-flex justify-content-between">
            <el-form-item label="會員生日月份" class="half-item">
              <br />
              <el-select v-model="memberFilterData.birthdayMonth" placeholder="選擇生日月份" clearable>
                <el-option v-for="month in 12" :key="month" :label="`${month}月`" :value="month"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="選擇會員等級" class="half-item">
              <br />
              <el-select v-model="memberFilterData.memberLevelIds" placeholder="選擇會員等級" clearable>
                <el-option v-for="level in memberLevelList" :key="level.id" :label="level.title" :value="level.id"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <el-form-item label="選擇標籤">
            <br />
            <el-select v-model="memberFilterData.tagIds" multiple placeholder="過濾標籤">
              <el-option v-for="tag in tagList" :key="tag.id" :label="tag.title" :value="tag.id"></el-option>
            </el-select>
          </el-form-item>
          <div class="d-flex justify-content-between">
            <el-form-item label="是否為黑名單" class="half-item">
              <br />
              <el-select v-model="memberFilterData.block" placeholder="選擇黑名單" clearable>
                <el-option :key="`list-tag-y`" label="是" value="1"></el-option>
                <el-option :key="`list-tag-n`" label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="LineNotify綁定狀態" class="half-item">
              <br />
              <el-select v-model="memberFilterData.lineNotifyStatus" placeholder="選擇綁定狀態" clearable>
                <el-option :key="`list-tag-y`" label="是" value="1"></el-option>
                <el-option :key="`list-tag-n`" label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </template>
        <template v-else>
          <el-form-item label="日期區間" :label-position="'top'">
            <br />
            <el-date-picker v-model="dateRange" type="monthrange" range-separator="至" start-placeholder="起始月份" end-placeholder="结束月份" align="right" style="background-color: white;">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="單次消費金額">
            <br />
            <div class="d-flex">
              <div class="w-50 d-flex">
                <template v-if="memberFilterData.singleAmount.type === 'between'">
                  <div class="d-flex w-50">
                    <el-input v-model="memberFilterData.singleAmount.min"></el-input>
                    <span class="ml-2">至</span>
                  </div>
                  <div class="d-flex w-50 pl-2">
                    <el-input v-model="memberFilterData.singleAmount.max"></el-input>
                    <span class="ml-2">元</span>
                  </div>
                </template>
                <template v-else>
                  <el-input v-model="memberFilterData.singleAmount.value"></el-input>
                  <span class="ml-2">元</span>
                </template>
              </div>
              <div class="w-50 d-flex align-items-center justify-content-around pl-2">
                <el-radio-group v-model="memberFilterData.singleAmount.type">
                  <el-radio
                    v-for="type in priceTypeList"
                    :key="type.label"
                    :label="type.label"
                    class="border rounded p-3"
                    :class="memberFilterData.singleAmount.type === type.label ? 'border-primary' : ''"
                    >{{ type.title }}</el-radio
                  >
                </el-radio-group>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="累計消費金額">
            <br />
            <div class="d-flex">
              <div class="w-50 d-flex">
                <template v-if="memberFilterData.totalAmount.type === 'between'">
                  <div class="d-flex w-50">
                    <el-input v-model="memberFilterData.totalAmount.min"></el-input>
                    <span class="ml-2">至</span>
                  </div>
                  <div class="d-flex w-50 pl-2">
                    <el-input v-model="memberFilterData.totalAmount.max"></el-input>
                    <span class="ml-2">元</span>
                  </div>
                </template>
                <template v-else>
                  <el-input v-model="memberFilterData.totalAmount.value"></el-input>
                  <span class="ml-2">元</span>
                </template>
              </div>
              <div class="w-50 d-flex align-items-center justify-content-around pl-2">
                <el-radio-group v-model="memberFilterData.totalAmount.type">
                  <el-radio
                    v-for="type in priceTypeList"
                    :key="type.label"
                    :label="type.label"
                    class="border rounded p-3"
                    :class="memberFilterData.totalAmount.type === type.label ? 'border-primary' : ''"
                    >{{ type.title }}</el-radio
                  >
                </el-radio-group>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="多久以上未有消費紀錄 (含預約/儲值/包月)">
            <br />
            <el-select v-model="memberFilterData.monthsWithoutOrder" placeholder="選擇未消費時長" clearable>
              <el-option v-for="month in 6" :key="month" :label="`${month}個月未消費`" :value="month"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-loading="serviceLoading" label="是否購買過服務項目" class="radio-group">
            <br />
            <el-radio-group v-model="hasBoughtServices" class="w-100" @change="tryToSearchConsumptionRecord('service')">
              <el-radio class="w-100 rounded border mb-2 p-3" :label="false" :class="{ 'border-primary': !hasBoughtServices }">否</el-radio>
              <el-radio class="w-100 rounded border p-3" :label="true" :class="{ 'border-primary': hasBoughtServices }"
                >是
                <template v-if="hasBoughtServices">
                  <p class="mt-4" style="color: black;">請選擇購買過的服務項目(可複選)</p>
                  <div style="max-height: 150px; overflow: scroll;">
                    <el-checkbox-group v-model="memberFilterData.serviceIds">
                      <el-row :gutter="20">
                        <el-col v-for="service in serviceList" :key="service.id" :span="12" class="mb-2">
                          <el-checkbox :label="service.id" class="checkbox-item p-3 w-100 rounded">{{ `${service.title}-${service.category}` }}</el-checkbox>
                        </el-col>
                      </el-row>
                    </el-checkbox-group>
                  </div>
                </template>
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-loading="prepaidLoading" label="是否購買過套裝課程" class="radio-group">
            <br />
            <el-radio-group v-model="hasBoughtPrepaids" class="w-100" @change="tryToSearchConsumptionRecord('prepaid')">
              <el-radio class="w-100 rounded border mb-2 p-3" :label="false" :class="{ 'border-primary': !hasBoughtPrepaids }">否</el-radio>
              <el-radio class="w-100 rounded border p-3" :label="true" :class="{ 'border-primary': hasBoughtPrepaids }"
                >是
                <template v-if="hasBoughtPrepaids">
                  <p class="mt-4" style="color: black;">請選擇購買過的套裝課程(可複選)</p>
                  <div style="max-height: 150px; overflow: scroll;">
                    <el-checkbox-group v-model="memberFilterData.prepaidGroupOrderingIds">
                      <el-row :gutter="20">
                        <el-col v-for="prepaid in prepaidList" :key="prepaid.id" :span="12" class="mb-2">
                          <el-checkbox :label="prepaid.id" class="checkbox-item p-3 w-100 rounded">{{ `${prepaid.title}-${prepaid.store}` }}</el-checkbox>
                        </el-col>
                      </el-row>
                    </el-checkbox-group>
                  </div>
                </template>
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </template>
        <el-form-item class="btn-group">
          <div class="d-flex justify-content-between">
            <el-button round @click="closeMemberFilterForm">取消</el-button>
            <el-button round type="primary" @click="tryToSearchFilter">確認篩選</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    memberLevelList: {
      type: Array,
      required: true,
    },
    tagList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      memberFilterData: {
        gender: 'female',
        birthdayMonth: '',
        monthsWithoutOrder: '',
        lineNotifyStatus: '',
        memberLevelIds: '',
        tagIds: [],
        block: '',
        startDate: '',
        endDate: '',
        singleAmount: {
          type: 'between',
          value: 0,
          min: 0,
          max: 0,
        },
        totalAmount: {
          type: 'between',
          value: 0,
          min: 0,
          max: 0,
        },
        serviceIds: [],
        prepaidGroupOrderingIds: [],
      },
      dateRange: [],
      hasBoughtServices: false,
      hasBoughtPrepaids: false,
      serviceLoading: false,
      prepaidLoading: false,
      activeTab: 'level',
      tabList: [{ label: '依消費紀錄', key: 'record' }, { label: '依會員等級', key: 'level' }],
      priceTypeList: [{ label: 'between', title: '區間' }, { label: 'greater', title: '以上' }, { label: 'less', title: '以下' }],
      serviceList: [],
      prepaidList: [],
    }
  },
  //   computed: {
  //     date() {
  //       const test = this.memberFilterData.date
  //       if (test.length) {
  //         return test.map(item => moment(item).format('YYYY-MM'))
  //       }
  //       return []
  //     },
  //   },
  methods: {
    closeMemberFilterForm() {
      this.$emit('close')
    },
    tryToSearchFilter() {
      this.formatSubmitData()
      this.$emit('search', this.memberFilterData)
    },
    async tryToSearchConsumptionRecord(type) {
      if (this.hasBoughtServices && type === 'service') {
        try {
          this.serviceLoading = true
          const { items } = await this.$store.dispatch('product/fetchNormalServiceData', {
            types: ['cosmetic'],
          })
          this.serviceList = items.map((service) => {
            return {
              id: service.id,
              category: service.petCategoryTitle,
              title: service.title,
            }
          })
        } catch (err) {
          throw err
        } finally {
          this.serviceLoading = false
        }
        return
      }
      if (this.hasBoughtPrepaids && type === 'prepaid') {
        try {
          this.prepaidLoading = true
          const { items } = await this.$store.dispatch('prepaid/fetchListAll', {
            categoryId: '',
            groupByGroupOrdering: true,
            productIds: [],
            search: '',
          })
          this.prepaidList = items.map((prepaid) => {
            return {
              id: prepaid.groupOrdering,
              store: prepaid.stores[0],
              title: prepaid.title,
            }
          })
        } catch (err) {
          throw err
        } finally {
          this.prepaidLoading = false
        }
      }
    },
    formatSubmitData() {
      if (this.dateRange.length) {
        this.dateRange = this.dateRange.map((date) => moment(date).format('YYYY-MM'))
        this.memberFilterData = {
          ...this.memberFilterData,
          startDate: this.dateRange[0] || '',
          endDate: this.dateRange[1] || '',
        }
      }
      const validPrice = (data) => {
        const { type, min, max, value } = data

        return type === 'between' ? max > min : !!value
      }
      const { singleAmount, totalAmount } = this.memberFilterData
      this.memberFilterData.singleAmount = validPrice(singleAmount) ? this.memberFilterData.singleAmount : []
      this.memberFilterData.totalAmount = validPrice(totalAmount) ? this.memberFilterData.totalAmount : []
    },
  },
}
</script>
